import * as Styled from './styles';

const Volunteer = () => (
    <Styled.List>
        <li>
            <Styled.Strong>Web Accessibility extension project within Reactstrap:</Styled.Strong> Applying digital
            inclusion concepts and WCAG standards in corporate environments.
        </li>
    </Styled.List>
);

export default Volunteer;
